var exports = {
  "dw": "BanDetailsModal.module__userSection___V3E1bE",
  "my": "BanDetailsModal.module__avatar___V3E1bE",
  "rZ": "BanDetailsModal.module__avatarPlaceholder___V3E1bE",
  "eF": "BanDetailsModal.module__userInfo___V3E1bE",
  "Xh": "BanDetailsModal.module__username___V3E1bE",
  "Tc": "BanDetailsModal.module__tag___V3E1bE",
  "zH": "BanDetailsModal.module__details___V3E1bE",
  "wV": "BanDetailsModal.module__detailRow___V3E1bE",
  "M": "BanDetailsModal.module__detailLabel___V3E1bE",
  "zL": "BanDetailsModal.module__detailValue___V3E1bE",
  "oc": "BanDetailsModal.module__noReason___V3E1bE",
  "S4": "BanDetailsModal.module__moderator___V3E1bE",
  "Y1": "BanDetailsModal.module__unknownModerator___V3E1bE",
};

module.exports = exports;
